module.exports = __webpack_public_path__ + "img/turnIcon.a253b050.png";